import { css, cx } from "@emotion/css"

import { Surface } from "components/Surface"

const styles = {
  pageHeader: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--spacing-s) 0;
    padding-bottom: var(--spacing-m);
    background-color: transparent;
    border: none;
  `,
  titleContainer: css`
    display: flex;
    align-items: center;
    max-width: 400px;
    padding-right: var(--spacing-m);
  `,
  label: css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
}

type PageHeaderProps = {
  label?: string
  badge?: React.ReactNode
  subLabel?: React.ReactNode
  children?: React.ReactNode
  className?: string
}

export function Header(props: PageHeaderProps) {
  const { label, children, className, badge, subLabel } = props

  return (
    <Surface className={cx(styles.pageHeader, className)}>
      <div>
        <div className={styles.titleContainer}>
          <h1 className={cx("HeadlineH4BlackBold", styles.label)}>{label}</h1>
          {badge}
        </div>
        {subLabel}
      </div>
      {children}
    </Surface>
  )
}
